<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "TrafictViolationIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
